export interface IModal {
    type: string;
    title?: string;
    contentText?: string;
    isOpen: boolean;
    onClose: () => void;
    isLoading?: boolean;
    onSubmit: () => void;
    content: any;
    maxWidth?: string;
    fullScreen?: boolean;
    isValid?: boolean;
    callback?: () => void;
    actionPosition?: string;
    cancelLabel?: string;
    confirmLabel?: string;
}

export enum ModalType {
    CONFIRMATION = 'CONFIRMATION',
    FORM = 'FORM',
    REVIEW = 'REVIEW',
    CUSTOM = 'CUSTOM',
}


// WEBPACK FOOTER //
// ./src/type/modal.ts